import { LegalPage, LegalSection } from "@/pages/LegalPage";

export default function About() {
  return (
    <LegalPage
      eyebrow="About"
      title="Built by reps, for reps."
      subtitle="SalesPit is the fastest way to sharpen your sales craft — one live mock at a time."
    >
      <LegalSection title="What is SalesPit?" testid="about-what">
        <p>
          SalesPit is a live sales practice platform for salespeople. Sign
          in and get instantly matched with another rep for a real, on-camera
          mock call. No scheduling, no waiting — just reps, whenever you're
          ready to practise.
        </p>
      </LegalSection>

      <LegalSection title="Why we built it" testid="about-why">
        <p>
          Every serious sales rep knows the same truth: you get better by
          running more calls. But finding reliable practice partners is
          brutally hard. Roleplays get scheduled, then cancelled. Time zones
          collide. Managers are busy. The reps who improve fastest are the
          ones who happen to have a partner nearby — everyone else stalls.
        </p>
        <p>
          SalesPit exists to erase that gap. It matches sales reps around the
          world for live mock calls the moment they're ready to practice, so
          getting reps in is as simple as opening the app.
        </p>
      </LegalSection>

      <LegalSection title="Our mission" testid="about-mission">
        <p className="rounded-2xl border border-[#E52525]/25 bg-[#E52525]/[0.06] px-6 py-5 text-lg font-medium text-white">
          Our mission is to help sales professionals improve faster through
          consistent, realistic practice.
        </p>
      </LegalSection>
    </LegalPage>
  );
}
